module.exports = __webpack_public_path__ + "static/media/covid.95ffb0fa.png";